import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { ClientLayout } from 'Components/ComponentLibrary/Organisms/ClientLayout';
import React from 'react';
import PropTypes from 'prop-types';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import SecondaryPersonIdentityVerification
  from 'Components/ComponentLibrary/Organisms/ClientDetailForm/SecondaryPersonIdentityVerification/SecondaryPersonIdentityVerification';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['isIdentityVerified'], {
    _component: () => SecondaryPersonIdentityVerification,
  }, overrideReadOnly);

export const DesktopManageHouseholdMember = ({ resource, onDeleteMember, onSubmitSuccess }) => {
  return (
    <MetaResourceRenderer
      layout={ClientLayout}
      LayoutProps={{
        onSuccessfulSubmit: onSubmitSuccess,
      }}
      fieldsImmediatelyRequired
      resource={resource}
      onSubmit={onSubmitSuccess}
      onDelete={onDeleteMember}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

DesktopManageHouseholdMember.propTypes = {
  resource: PropTypes.object.isRequired,
  onDeleteMember: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
};
